// Internal matcher logic
function match(value, matcher, testValue) {
  switch (matcher) {
    case 'is':
    case '===':
    case '==': return value === testValue;
    case 'not':
    case '!==':
    case '!=': return value !== testValue;
    case 'includes': return Array.isArray(value) && value.includes(testValue);
    case 'has': return typeof value === 'object' && value !== null && Object.values(value).includes(testValue);
    case 'in': return typeof value === 'object' && value !== null && testValue in value;
    case 'gt':
    case '>': return value > testValue;
    case 'lt':
    case '<': return value < testValue;
    case 'gte':
    case '>=': return value >= testValue;
    case 'lte':
    case '<=': return value <= testValue;
    default: throw new Error(`Unknown matcher: ${matcher}`);
  }
}

export function seekWhen(obj, targetKey, matcher, testValue, currentPath = [], findAll = false) {
  const results = [];

  if (obj === null || typeof obj !== 'object') return results;

  for (const [key, value] of Object.entries(obj)) {
    // ✅ Check the key directly
    if (key === targetKey && match(value, matcher, testValue)) {
      results.push([...currentPath, key]);
      if (!findAll) return results;
    }

    // ✅ Recurse if object/array
    if (typeof value === 'object' && value !== null) {
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          const item = value[i];
          if (item && typeof item === 'object') {
            const nested = seekWhen(item, targetKey, matcher, testValue, [...currentPath, key, i], findAll);
            results.push(...nested);
            if (!findAll && results.length > 0) return results;
          }
        }
      } else {
        const nested = seekWhen(value, targetKey, matcher, testValue, [...currentPath, key], findAll);
        results.push(...nested);
        if (!findAll && results.length > 0) return results;
      }
    }
  }

  return results;
}

// Helper functions for common search patterns
export function findWhen(obj, key, matcher = 'is', value) {
  return seekWhen(obj, key, matcher, value, [], false)?.[0];
}

export function findAllWhen(obj, key, matcher = 'is', value) {
  return seekWhen(obj, key, matcher, value, [], true);
}

function matchesQuery(obj, query) {
  const keys = Object.keys(query);
  if (keys.length === 0) return false;
  for (let i = 0; i < keys.length; i++) {
    if (obj[keys[i]] !== query[keys[i]]) return false;
  }
  return true;
}

export function seekWhere(obj, query, currentPath = [], findAll = false) {
  const results = [];

  if (obj === null || typeof obj !== 'object') return results;

  if (matchesQuery(obj, query)) {
    results.push([...currentPath]);
    if (!findAll) return results;
  }

  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      const item = obj[i];
      if (item && typeof item === 'object') {
        const nested = seekWhere(item, query, [...currentPath, i], findAll);
        results.push(...nested);
        if (!findAll && results.length > 0) return results;
      }
    }
  } else {
    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === 'object' && value !== null) {
        const nested = seekWhere(value, query, [...currentPath, key], findAll);
        results.push(...nested);
        if (!findAll && results.length > 0) return results;
      }
    }
  }

  return results;
}

export function findWhere(obj, query) {
  return seekWhere(obj, query, [], false)?.[0];
}

export function findAllWhere(obj, query) {
  return seekWhere(obj, query, [], true);
}